(ns frontend.view.nev.zap-vault.tab-disclaimer
  (:require [common.localization :as loc]
            [frontend.view.nev.zap-vault.event :as event]
            [frontend.view.nev.zap-vault.sub :as sub]
            [re-frame.core :as rf]
            [ui.components.button.view :as button]
            [ui.components.layout.footer :as footer]
            [ui.components.modal.style :as modal-style]
            [ui.components.modal.view :as modal]
            [ui.components.rich-text.tiptap :as tiptap]
            [ui.components.text.view :as text]
            [ui.editors.data-input :as data-input]
            [ui.editors.labelled-input.view :as labelled-input]))

(defn preview-modal
  []
  (let [visible? @(rf/subscribe [::sub/preview?])
        vault-config @(rf/subscribe [::sub/config-with-updates])
        checked? @(rf/subscribe [::sub/preview-confirmed?])]
    [modal/view
     {:visible? visible?
      :size     ::modal-style/md}
     (loc/tr :disclaimer)
     [:div
      {:class "flex-auto flex flex-col gap-4"}
      [tiptap/viewer
       {:value (:vault-config/disclaimer-message vault-config)
        :styles {:backgroundColor "transparent"
                 :border "none"}}]

      [:div
       {:class "p-2 bg-base-regular text-base-regular-text rounded border border-1 border-base-regular-border-paler"}
       [:label
        {:class "text-n-xs text-input-light-text font-semibold flex flex-row gap-2 items-center"}
        [data-input/view
         {:editor-type :editor.type/checkbox
          :value       checked?
          :on-change   (fn [v]
                         (rf/dispatch [::event/set-preview-confirmed? v]))}]
        (:vault-config/disclaimer-confirm-text vault-config)]]
      [footer/footer
       [footer/left-align]
       [footer/right-align
        [button/secondary-hollow
         {:on-click (fn [_]
                      (rf/dispatch [::event/close-preview!]))}
         (loc/tr :exit)]
        [button/primary-solid
         {:on-click  (fn [_]
                       (rf/dispatch [::event/close-preview!]))
          :disabled? (not checked?)}
         (loc/tr :continue)]]]]]))

(defn view
  []
  (let [config @(rf/subscribe [::sub/config-with-updates])
        changes @(rf/subscribe [::sub/vault-and-config-changes])]
    [:div
     {:class "flex flex-col gap-2 border border-solid border-base-light-border-paler"}
     [:div
      {:class "flex flex-col gap-1 p-4 pb-0"}
      [text/h2
       (loc/tr :zap-vault-disclaimer)]
      [text/info-text
       (loc/tr :zap-vault-disclaimer-info)]]
     [:div
      {:class "flex flex-col gap-2 p-4 bg-base-regular items-start"}
      [:div
       {:class "flex flex-col gap-2 w-full max-w-[600px]"}
       [labelled-input/view
        {:label     (loc/tr :vault-config/disclaimer-message)
         :value     (:vault-config/disclaimer-message config)
         :data-type :data.type/text-richtext
         :on-change (fn [v]
                      (rf/dispatch [::event/config-change :vault-config/disclaimer-message v]))}]
       [labelled-input/view
        {:label     (loc/tr :vault-config/disclaimer-confirm-text)
         :value     (:vault-config/disclaimer-confirm-text config)
         :data-type :data.type/text-simple
         :on-change (fn [v]
                      (rf/dispatch [::event/config-change :vault-config/disclaimer-confirm-text v]))}]

       [footer/footer
        [footer/left-align
         (when (seq changes)
           [button/secondary-hollow
            {:on-click #(rf/dispatch [::event/cancel-changes])}
            (loc/tr :cancel)])]
        [footer/right-align
         [button/sm-secondary-hollow
          {:on-click (fn [_]
                       (rf/dispatch [::event/preview-disclaimer]))}
          (loc/tr :preview)]
         [button/primary-solid
          {:on-click  (fn [_]
                        (rf/dispatch [::event/save-changes changes]))
           :disabled? (empty? changes)}
          (loc/tr :save)]]]]]
     [preview-modal]]))
